import logToNewRelic from "./logToNewRelic";
import logToConsole from "./logToConsole";
import global from "global";

export default (level, detail, attributes) => {
  if (global.newrelic) {
    logToNewRelic(level, detail, attributes);
  } else {
    logToConsole(level, detail, attributes);
  }
};
